import React from 'react';
import Link from "next/link";

const Footer = ({t}) => {

    const footer = t('common:footer', {}, {returnObjects: true});

    const FooterBlock = ({block}) => {
        return <li className={'block_item'}>
            <ol className={'block_items'}>
                {block.map(el => {
                    return <li key={el.title} className={'block_items_item'}>
                        <Link target={el.target || '_self'}  href={el.link} rel={el.target === "_blank" ? "noopener noreferrer" : ''}>
                            {el.title}
                        </Link>
                    </li>
                })}
            </ol>
        </li>
    }

    return (
        <footer className={'footer'}>
            <div className="container">
                <div className="footer_wrapper">
                <div className="footer_social">
                    <svg className={'footer_social_logo'} xmlns="http://www.w3.org/2000/svg" width="26" height="26"
                         viewBox="0 0 26 26" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M11.0547 0V5.90188H14.192L14.192 0H11.0547ZM11.0547 19.747V25.254H14.192L14.192 19.747H11.0547ZM25.2518 14.1956H19.7448V11.0582L25.2518 11.0582V14.1956ZM0 14.1956H5.90188V11.0582L0 11.0582V14.1956ZM20.4666 22.8862L13.0194 15.4389L15.2378 13.2205L22.6851 20.6678L20.4666 22.8862ZM2.56225 4.9812L10.0095 12.4285L12.228 10.2101L4.78068 2.76278L2.56225 4.9812ZM22.6871 4.98112L15.2398 12.4284L13.0214 10.21L20.4687 2.76269L22.6871 4.98112ZM4.78018 22.8861L12.2275 15.4388L10.009 13.2204L2.56176 20.6677L4.78018 22.8861Z"
                              fill="#3366FF"/>
                    </svg>
                    <div className="footer_social_line"/>
                    <div className={'footer_social_list'}>
                        <a rel={"noopener noreferrer"} className={'social_item'} aria-label={'Telegram'} href={'https://t.me/coldwarenetwork'}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                 fill="none">
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM9.80679 6.42536L3.7461 8.92247C2.67962 9.33866 3.3039 9.72883 3.3039 9.72883C3.3039 9.72883 4.2143 10.041 4.99465 10.2751C5.775 10.5092 6.19118 10.2491 6.19118 10.2491L9.85881 7.77796C11.1594 6.89357 10.8473 7.6219 10.5351 7.93403C9.85881 8.61033 8.74032 9.67681 7.8039 10.5352C7.38771 10.8994 7.59581 11.2115 7.77789 11.3676C8.30721 11.8154 9.55355 12.6298 10.1202 13C10.2775 13.1028 10.3824 13.1714 10.4051 13.1884C10.5351 13.2924 11.2634 13.7606 11.7056 13.6566C12.1478 13.5525 12.1999 12.9543 12.1999 12.9543L12.8501 8.87045C12.9079 8.48759 12.9657 8.11276 13.0196 7.76322C13.1598 6.85413 13.2736 6.11614 13.2923 5.85311C13.3704 4.96872 12.434 5.33288 12.434 5.33288C12.434 5.33288 10.4051 6.16525 9.80679 6.42536Z"
                                      fill="#000034"/>
                            </svg>
                        </a>
                        <a rel={"noopener noreferrer"} className={'social_item'} aria-label={'Twitter(X)'} href={'https://x.com/ColdwareNetwork'}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                 fill="none">
                                <path
                                    d="M13.0525 2.625H15.2139L10.4918 8.02575L16.047 15.375H11.6973L8.2905 10.9178L4.39228 15.375H2.22952L7.28032 9.59828L1.95117 2.625H6.41129L9.4908 6.69911L13.0525 2.625ZM12.2939 14.0803H13.4915L5.7605 3.85162H4.47527L12.2939 14.0803Z"
                                    fill="#000034"/>
                            </svg>
                        </a>
                    </div>
                </div>
                <div className="footer_main">
                    <p className={'footer_main_description'}>{footer.description}</p>
                    <nav className={'footer_main_nav'}>
                        <ul className={'nav_items'}>
                            {footer.links.map((block, i) => {
                                return <FooterBlock
                                    key={i}
                                    block={block}
                                />
                            })}
                        </ul>
                    </nav>
                </div>
                <div className="footer_bottom">
                    <p className={'footer_bottom_reserved'}>{footer.reserved}</p>
                    <p className={'footer_bottom_disclaimer'}>{footer.disclaimer}</p>
                </div>
                <div className={'footer_social_list mobile'}>
                    <a rel={"noopener noreferrer"} className={'social_item'} aria-label={'Telegram'} href={'https://t.me/coldwarenetwork'}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                             fill="none">
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM9.80679 6.42536L3.7461 8.92247C2.67962 9.33866 3.3039 9.72883 3.3039 9.72883C3.3039 9.72883 4.2143 10.041 4.99465 10.2751C5.775 10.5092 6.19118 10.2491 6.19118 10.2491L9.85881 7.77796C11.1594 6.89357 10.8473 7.6219 10.5351 7.93403C9.85881 8.61033 8.74032 9.67681 7.8039 10.5352C7.38771 10.8994 7.59581 11.2115 7.77789 11.3676C8.30721 11.8154 9.55355 12.6298 10.1202 13C10.2775 13.1028 10.3824 13.1714 10.4051 13.1884C10.5351 13.2924 11.2634 13.7606 11.7056 13.6566C12.1478 13.5525 12.1999 12.9543 12.1999 12.9543L12.8501 8.87045C12.9079 8.48759 12.9657 8.11276 13.0196 7.76322C13.1598 6.85413 13.2736 6.11614 13.2923 5.85311C13.3704 4.96872 12.434 5.33288 12.434 5.33288C12.434 5.33288 10.4051 6.16525 9.80679 6.42536Z"
                                  fill="#000034"/>
                        </svg>
                    </a>
                    <a rel={"noopener noreferrer"} className={'social_item'} aria-label={'Twitter(X)'} href={'https://x.com/ColdwareNetwork'}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                             fill="none">
                            <path
                                d="M13.0525 2.625H15.2139L10.4918 8.02575L16.047 15.375H11.6973L8.2905 10.9178L4.39228 15.375H2.22952L7.28032 9.59828L1.95117 2.625H6.41129L9.4908 6.69911L13.0525 2.625ZM12.2939 14.0803H13.4915L5.7605 3.85162H4.47527L12.2939 14.0803Z"
                                fill="#000034"/>
                        </svg>
                    </a>
                </div>
            </div>
            </div>
        </footer>
    );
};

export default Footer;